import { useRef, useState } from "react";
import { FileStack } from "lucide-react";

const hasFiles = (e) => [...(e.dataTransfer?.types || [])].includes("Files");

export const LoadsDropTarget = ({ onFiles, disabled, children }) => {
  const [over, setOver] = useState(false);
  const depth = useRef(0);
  const enter = (e) => { if (!hasFiles(e)) return; e.preventDefault(); depth.current += 1; if (!disabled) setOver(true); };
  const leave = (e) => { if (!hasFiles(e)) return; depth.current = Math.max(0, depth.current - 1); if (!depth.current) setOver(false); };
  const drop = (e) => {
    if (!hasFiles(e)) return;
    e.preventDefault();
    depth.current = 0;
    setOver(false);
    if (!disabled && e.dataTransfer.files?.length) onFiles(e.dataTransfer.files);
  };
  return (
    <div className="relative" onDragEnter={enter} onDragOver={(e) => { if (hasFiles(e)) e.preventDefault(); }} onDragLeave={leave} onDrop={drop}
      data-testid="loads-dropzone" data-dragging={over ? "true" : "false"}>
      {children}
      {over && (
        <div className="absolute inset-0 z-20 rounded-xl border-2 border-dashed border-[#002FA7] bg-blue-50/90 backdrop-blur-sm grid place-items-center pointer-events-none" data-testid="loads-drop-overlay">
          <div className="text-center">
            <div className="w-14 h-14 mx-auto rounded-2xl bg-[#002FA7] text-white grid place-items-center"><FileStack className="w-7 h-7" /></div>
            <p className="mt-3 text-lg font-semibold text-slate-900">Drop ratecons to read them with AI</p>
            <p className="text-sm text-slate-600">PDFs or photos. You&apos;ll review every load before it&apos;s created.</p>
          </div>
        </div>
      )}
    </div>
  );
};
